<script>
import Repositories from '@/repositories';
const OrderReceptionsRepository = Repositories.get('orderreceptions');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/fr';
import moment from 'moment';
import scrollMixin from '@/mixins/scrollWheelMixin';

export default {
  props: {
    orderIdPublic: String,
    orderItems: Array,
  },
  components: {
    Loading,
    DatePicker,
  },
  mixins: [scrollMixin],
  data() {
    return {
      orderItemsList: [],
      isLoading: false,
      receptionNumber: '',
      receptionDate: '',
    };
  },
  methods: {
    modalHidden() {
      this.orderItemsList = [];
      this.$emit('modal-closed');
    },
    closeModal() {
      this.$bvModal.hide('order-reception-modal');
    },
    modalShown() {
      this.receptionNumber = '';
      this.receptionDate = moment().format('YYYY-MM-DD');
      this.loadFirstTime();
    },
    loadFirstTime() {
      this.isLoading = true;

      this.orderItemsList = [];

      if (this.orderIdPublic != null) {
        this.orderItemsList = this.orderItems
          .map((x) => {
            x.receptionQuantity = this.toFloat(x.toReceive);
            if (x.isReceived && x.receptionQuantity > 0) {
              return x;
            } else {
              return false;
            }
          })
          .filter((x) => x != false);
        this.isLoading = false;
      }
    },
    orderReception() {
      this.isLoading = true;
      let orderReceptionOrderItems = this.orderItemsList
        .map((x) => {
          return {
            totalQuantity: x.receptionQuantity,
            orderItemIdPublic: x.idPublic,
            idPublic: null,
          };
        })
        .filter((x) => x.totalQuantity > 0);

      if (orderReceptionOrderItems.length > 0) {
        OrderReceptionsRepository.create({
          orderIdPublic: this.orderIdPublic,
          receptionNumber: this.receptionNumber,
          receptionDate: this.receptionDate,
          orderReceptionOrderItems: orderReceptionOrderItems,
        })
          .then((resp) => {
            this.isLoading = false;
            this.orderItemsList = [];
            this.$emit('reception-added', resp.data);

            this.closeModal();
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          });
      } else {
        this.isLoading = true;
        this.closeModal();
      }
    },
    wheelItBetter(event, orderItem) {
      orderItem.receptionQuantity = this.scrollMixinEvent(
        event,
        orderItem.receptionQuantity
      );

      this.onChange(orderItem);
    },
    onChange(orderItem) {
      if (isNaN(orderItem.receptionQuantity)) orderItem.receptionQuantity = 0;
      if (orderItem.receptionQuantity < 0) orderItem.receptionQuantity = 0;
      if (
        orderItem.receptionQuantity >
        this.toFloat(orderItem.totalQuantity - orderItem.receivedQuantity)
      ) {
        orderItem.receptionQuantity = this.toFloat(
          orderItem.totalQuantity - orderItem.receivedQuantity
        );
      }
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="order-reception-modal"
      scrollable
      centered
      no-close-on-backdrop
      size="lg"
      hide-header
      @shown="modalShown()"
      @hide="modalHidden()"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>

      <div style="margin: 20px; font-size: 1.2em">
        <b-row class="mb-3">
          <b-col cols="8" class="flex-middle">
            {{ $t('orders.receptionNumber') }}
          </b-col>
          <b-col cols="4">
            <b-form-input v-model="receptionNumber" type="text"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="8" class="flex-middle">
            {{ $t('orders.receptionDate') }}
          </b-col>
          <b-col cols="4">
            <date-picker
              v-model="receptionDate"
              :first-day-of-week="1"
              format="YYYY-MM-DD"
              value-type="format"
              :lang="$i18n.locale"
            >
            </date-picker>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center mt-4">
            <h3>{{ $t('items.receivedItems') }}</h3>
          </b-col>
        </b-row>
        <b-row
          class="mb-3"
          v-for="orderItem in orderItemsList"
          :key="orderItem.idPublic"
        >
          <b-col cols="8" class="flex-middle">
            {{
              orderItem.itemSupplierName != null &&
              orderItem.itemSupplierName.trim().length > 0
                ? orderItem.itemSupplierName
                : orderItem.itemName
            }}
          </b-col>
          <b-col cols="4">
            <div class="text-right">
              {{ orderItem.receptionQuantity }}
            </div>
          </b-col>
        </b-row>

        <b-button
          style="margin-bottom: 50px"
          @click="orderReception()"
          block
          size="lg"
          variant="primary"
        >
          {{ $t('orders.reception') }}
        </b-button>
      </div>

      <template #modal-footer>
        <b-button @click="closeModal()" size="sm" variant="danger">
          {{ $t('general.close') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
.flex-middle {
  display: flex;
  align-items: center;
}
</style>